
/* injects from baggage-loader */

'use strict';

/**
 * services to stock session variables on the browser memory.
 *
 * @export
 * @param {AngularModule} app
 */
export default function (app) {
	app.factory('sessionFactory', sessionFactory);

	/**
	 * services to stock session variables on the browser memory
	 */
	function sessionFactory(utilitiesConstant) {
		'ngInject';

		/**
		 * Call to the encryptedStorage.js to encrypt data when it has instantiated.
		 * It sends the encryption key and storage type.
		 */
		const sessionEncrypt = new EncryptedStorage(utilitiesConstant.STORAGE.KEY, utilitiesConstant.STORAGE.TYPE);

		return {
			get: get,
			remove: remove,
			set: set
		};

		/*
		* Set session data.
		*/
		function set(key, val) {
			return sessionEncrypt.set(key, val);
		}

		/*
		* Remove session data.
		*/
		function remove(key) {
			return sessionEncrypt.remove(key);
		}

		/*
		* Get session data.
		*/
		function get(key) {
			return sessionEncrypt.get(key);
		}
	}

	/**
	 * <p>
	 * JavaScript used for stock browser memory encrypted variables, the user define the storage type and storage key
	 * </p>
	 *
	 * @author C Camilo Castellanos
	 * @since 10/11/2015 13:04:18
	 * @version 1.0
	 */
	const EncryptedStorage = (function (global) {
		'use strict';

		const CryptoJS = require("crypto-js");

		// constructor, validate sent of variables
		let EncryptedStorage = function (secret, tipoAlmacenamiento) {
			if (!secret) {
				throw 'Error, falta la llave de encripcion';
			}
			if (!tipoAlmacenamiento || (tipoAlmacenamiento !== 'localStorage' && tipoAlmacenamiento !== 'sessionStorage')) {
				throw 'Error, falta definir el tipo de almacenamiento, (i.e. localStorage, sessionStorage)';
			}
			this.secret = secret;
			this.tipoAlmacenamiento = tipoAlmacenamiento;
		};

		/**
		 * Definition of browser memory storage methods.
		 */
		EncryptedStorage.prototype = {

			/*
			* Return the encrypted value of the parameter received.
			*/
			get: function (key) {
				let encrypted = global[this.tipoAlmacenamiento].getItem(key);
				return encrypted && decrypt(encrypted, this.secret);
			},

			/*
			 * Encrypt and stock in the browser memory the variable received.
			 */
			set: function (key, object) {
				/**
				 * Validate if the data is sent, to remove it from the browser memory if does not sent.
				 */
				if (!object) {
					this.remove(key);
					return;
				}

				let encrypted = encrypt(object, this.secret);
				global[this.tipoAlmacenamiento].setItem(key, encrypted);
			},

			/*
			 * Remove from the browser memory the parameter received.
			 */
			remove: function (key) {
				global[this.tipoAlmacenamiento].removeItem(key);
			}
		};

		/*
		 * Encrypt the parameter received using the encryption key.
		 */
		function encrypt(object, secret) {
			let message = angular.toJson(object);
			return CryptoJS.TripleDES.encrypt(message, secret);
		}

		/*
		 * decrypt the parameter received using the encryption key
		 */
		function decrypt(encrypted, secret) {
			let decrypted = CryptoJS.TripleDES.decrypt(encrypted, secret);
			return angular.fromJson(decrypted.toString(CryptoJS.enc.Utf8));
		}

		return EncryptedStorage;
	}(window));
}





// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js